import {
  ChakraBox,
  ChakraFlex,
  ChakraGrid,
  ChakraToolTip,
  EquipUIFireflyV2Theme,
  Popover,
  Text,
} from '@equip.health/ui';
import { Fragment, useState } from 'react';

const { neutral } = EquipUIFireflyV2Theme.colors;

const SECONDARY_DIAGNOSES_DISPLAY_LIMIT = 2 as const;

type Props = {
  secondaryDiagnoses?: PatientDiagnosis[];
};

export const TreatmentOverviewCardSecondaryDiagnosesList = ({
  secondaryDiagnoses,
}: Props) => {
  const [isCoOccurringPopoverOpen, setIsCoOccurringPopoverOpen] =
    useState(false);

  if (!secondaryDiagnoses || secondaryDiagnoses.length === 0) {
    return <></>;
  }
  if (secondaryDiagnoses.length <= SECONDARY_DIAGNOSES_DISPLAY_LIMIT) {
    return (
      <ChakraFlex flexWrap="wrap" gap="8px">
        {secondaryDiagnoses.map((d) => (
          <ChakraToolTip
            bg="white"
            border={`1px solid ${neutral.line}`}
            borderRadius="8px"
            closeOnPointerDown
            color="neutral.secondary"
            gutter={3}
            hasArrow
            key={`patient-overview-diagnosis-secondary-diagnosis-tooltip-${d.externalId}`}
            label={d.diagnosis.shortDescription}
            marginLeft="8px"
            padding="8px"
            shouldWrapChildren
          >
            <ChakraBox
              borderColor="neutral.line"
              borderRadius="6px"
              borderWidth="1px"
              maxWidth="280px"
              padding="4px 8px"
            >
              <Text
                overflow="hidden"
                textOverflow="ellipsis"
                variant="captionMedium"
                whiteSpace="nowrap"
              >
                {d.diagnosis.shortDescription}
              </Text>
            </ChakraBox>
          </ChakraToolTip>
        ))}
      </ChakraFlex>
    );
  }
  return (
    <Popover
      bodyContent={
        <ChakraGrid columnGap="6px" gridTemplateColumns="44px 1fr" rowGap="6px">
          {secondaryDiagnoses.map(({ diagnosis, externalId }) => (
            <Fragment key={externalId}>
              <Text color="neutral.secondary" variant="caption">
                {diagnosis.code}
              </Text>
              <Text>{diagnosis.shortDescription}</Text>
            </Fragment>
          ))}
        </ChakraGrid>
      }
      bodyPadding="18px 24px"
      id="treatment-overview-card-secondary-diagnoses-list-popover"
      isOpen={isCoOccurringPopoverOpen}
      minWidth="375px"
      onClose={() => setIsCoOccurringPopoverOpen(false)}
      onOpen={() => {
        setIsCoOccurringPopoverOpen(true);
      }}
      size="md"
      trigger="hover"
      triggerContent={
        <ChakraBox
          borderColor="neutral.line"
          borderRadius="6px"
          borderWidth="1px"
          padding="4px 8px"
          width="min-content"
        >
          <Text
            overflow="hidden"
            textOverflow="ellipsis"
            variant="captionMedium"
            whiteSpace="nowrap"
          >
            {secondaryDiagnoses.length} co-occurring conditions
          </Text>
        </ChakraBox>
      }
    />
  );
};
